import humps from 'humps';
import {
  compose, converge,
  isEmpty,
  map,
  mergeRight, path,
  pathOr,
  pickBy,
  prop,
} from 'ramda';

import { mapPropNames, parsedQueryString } from '@ezugi/utils';

type AuthResult = {
  operatorId: string;
  token: string;
  [key: string]: any;
}

// TODO: Duplicate to packages/bootstrap/src/store/epics/auth/utils.js
function getAuthParams({ operatorId, token, ...rest }: AuthResult) {
  const identifier = `${operatorId}${token}`;
  return { ...rest, operatorId, token, identifier, ...parsedQueryString };
}

export const pluckAuthParams = compose(
  getAuthParams,
  prop('authenticationParams')
);

export const pluckSkin = compose(
  map(JSON.parse),
  pickBy(
    (value, key) => !isEmpty(value) && [ 'palette', 'typography', 'tints' ].includes(key)
  ),
  mapPropNames(humps.camelize),
  path([ 'config', 'skin' ])
);

export const pluckLocale = prop('locale');

export const pluckGame = converge(
  (ap: any, gt: any, gp: any) => mapPropNames(humps.camelize)({
    ...gt[ap.game_id],
    ...gp,
  }),
  [ pluckAuthParams, prop('gameTypes'), () => parsedQueryString ]
);

export const pluckGameTypes = compose(
  map(mapPropNames(humps.camelize)),
  prop('gameTypes')
);

export const pluckRedirectUrl = pathOr(null, [ 'referrerUrl' ]);

export const pluckLanguage = prop('language');

export const pluckIsEvoPlayer = compose(
  Boolean,
  path([ 'config', 'general', 'is_evo_player' ])
);

export const pluckDefinitions = prop('definitions');

export const pluckWidgets = path([ 'config', 'widgets' ]);

export const pluckRetail = path([ 'config', 'retail' ]);

export const pluckPreloader = compose<any, any, any>(
  mapPropNames(humps.camelize),
  converge(mergeRight, [
    path([ 'config', 'preloader' ]),
    path([ 'locale', 'preloader' ]),
  ] as any)
);

export const pluckSkinColors = compose(
  mapPropNames(humps.camelize),
  path([ 'config', 'skin_colors' ])
);

export const pluckFeatureFlags = compose(
  mapPropNames(humps.camelize),
  pathOr({}, [ 'config', 'feature_flags' ])
);

export const pluckErrorCode = compose(prop('errorCode'));

export const pluckOssConfig = path([ 'config', 'oss' ]);

export const pluckComplianceConfig = path([ 'config', 'compliance' ]);

export const pluckStreamsData = prop('streams');

export const pluckBonusConfig = path([ 'config', 'bonus' ]);
